<app-modal
  [isVisible]="isVisible()"
  [config]="modalConfig"
  [primaryButtonDisabled]="primaryButtonDisabled()"
  [primaryButtonLoading]="isLoading()"
  (confirmed)="onModalConfirmed()"
  (cancelled)="onModalCancelled()"
  (secondary)="onModalCancelled()"
  (closed)="onModalClosed()"
>
  <!-- Header Icon -->
  <div class="modal-header-icon">
    <app-icon iconKey="group" [showLabel]="false" />
  </div>

  <!-- Description -->
  <p class="modal-description">Send an invitation to join your organization.</p>

  <!-- Error Message -->
  @if (error(); as err) {
    <div class="modal-error">
      <span>{{ err }}</span>
      <button type="button" (click)="clearError()">×</button>
    </div>
  }

  <!-- Form Fields -->
  <div class="field">
    <label for="invite-email">Email Address</label>
    <div class="input-wrapper">
      <input
        id="invite-email"
        type="email"
        placeholder="member@example.com"
        [ngModel]="email()"
        (ngModelChange)="email.set($event); clearError()"
        [disabled]="isLoading()"
      />
      <app-icon iconKey="email" [showLabel]="false" class="input-trailing-icon" />
    </div>
    <small>An invitation email will be sent to this address</small>
  </div>

  <div class="field">
    <label for="invite-role">Role</label>
    <app-select
      variant="form"
      inputId="invite-role"
      [options]="roleOptions"
      [clearable]="false"
      [disabled]="isLoading()"
      [value]="role()"
      (valueChange)="role.set($any($event)); clearError()"
    />
    <small>Select the role for the new member</small>
  </div>
</app-modal>
